import { useEffect, useState } from "react"

import { listExternalSignatures } from "../api/external-signatures.services.ts"
import type { ExternalSignature } from "../types/external-signature.types.ts"

/** The documents filed as signed outside EZBuild on a lead; `reloadKey` refetches after a new one is filed. */
export const useLeadExternalSignatures = (leadId: string | undefined, reloadKey = 0) => {
  const [signatures, setSignatures] = useState<ExternalSignature[]>([])

  useEffect(() => {
    if (!leadId) return
    let abandoned = false
    void listExternalSignatures(leadId).then((found) => {
      if (!abandoned && found) setSignatures(found)
    })
    return () => {
      abandoned = true
    }
  }, [leadId, reloadKey])

  return signatures
}
